import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AlertCircle } from 'lucide-react';

interface DeleteLevelDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  levelName: string;
  childCount: number;
  onConfirm: () => void;
}

export function DeleteLevelDialog({
  open,
  onOpenChange,
  levelName,
  childCount,
  onConfirm,
}: DeleteLevelDialogProps) {
  const hasChildren = childCount > 0;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-warning-600" />
            <AlertDialogTitle>Delete Level?</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-2 pt-2">
            {hasChildren ? (
              <>
                <p className="font-medium text-foreground">
                  Delete '{levelName}' level?
                </p>
                <p>
                  This level has <span className="font-medium">{childCount}</span> cost centre{childCount !== 1 ? 's' : ''} underneath it. 
                  These cost centres will be removed from the structure and will be available in 'Add Existing' to re-add later.
                </p>
                <p>
                  The level itself will be permanently deleted.
                </p>
              </>
            ) : (
              <>
                <p className="font-medium text-foreground">
                  Delete '{levelName}' level?
                </p>
                <p>
                  This action cannot be undone.
                </p>
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-warning-600 hover:bg-warning-700 focus:ring-warning-600"
          >
            Delete Level
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
